import React from 'react';
import {DividedList, DividedListProps} from '../../elements/lists/DividedList';
import Grid, {GridSize, GridSpacing} from '@material-ui/core/Grid';
import {GridContainer} from '../../elements/grid/GridContainer';
import {AccentColorOptions} from 'epic-ue-theme';
import {Spotlight} from '../../wraps/spotlight/Spotlight.wrap';

type GridOptions = GridSize | boolean;

export interface SplitListSectionProps {
    accentColor?: AccentColorOptions;
    leftList?: DividedListProps;
    rightList?: DividedListProps;
    gridMd?:
        | '75-25'
        | '66-33'
        | '50-50'
        | '33-66'
        | '25-75'
        | [GridOptions, GridOptions]
        | undefined;
    gridSpacing?: GridSpacing | undefined;
    hidden?: boolean;
}

export const SplitListSection = (props: SplitListSectionProps): JSX.Element | null => {
    const {accentColor, leftList, rightList, gridMd, gridSpacing = 4, hidden = false} = props;

    if (hidden) return null;

    let leftMd: GridOptions;
    let rightMd: GridOptions;

    switch (gridMd) {
        case '75-25': {
            leftMd = 9;
            rightMd = 3;
            break;
        }
        case '66-33': {
            leftMd = 8;
            rightMd = 4;
            break;
        }
        case '50-50': {
            leftMd = 6;
            rightMd = 6;
            break;
        }
        case '33-66': {
            leftMd = 4;
            rightMd = 8;
            break;
        }
        case '25-75': {
            leftMd = 3;
            rightMd = 9;
            break;
        }
        default: {
            if (gridMd && gridMd[1] !== undefined) {
                leftMd = gridMd && gridMd[0];
                rightMd = gridMd && gridMd[1];
            } else {
                leftMd = 7;
                rightMd = 4;
            }
            break;
        }
    }

    return (
        <div className="split-list-section">
            <GridContainer>
                <Spotlight
                    accentColor={accentColor}
                    variant="big"
                    shape="oval"
                    tilt="left"
                    offsetRatio={[0.2, 0.2]}
                    offsetRatioDown={[0.2, 0.7]}>
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="stretch"
                        direction="row"
                        spacing={gridSpacing}>
                        <Grid item xs={12} md={leftMd}>
                            <DividedList {...leftList} accentColor={accentColor} />
                        </Grid>
                        <Grid item xs={12} md={rightMd}>
                            <DividedList {...rightList} accentColor={accentColor} />
                        </Grid>
                    </Grid>
                </Spotlight>
            </GridContainer>
        </div>
    );
};
